import axios from 'axios';
import moment from 'moment';

class BaseMitCSAILLdapService {
  constructor() {
  }
  
  requestGetUsers(searchterm, searchType) {
    return new Promise ((resolve, reject) => {
      if(typeof(searchterm) === 'undefined' || searchterm === null || (searchterm == '')){
        return resolve({users:[]});
      }
      //default to search by id
      let url = '/api/v1/ldap/id/exactandpotential/'

      //use search by name otherwise
      if(searchType === 'name'){
        url = '/api/v1/ldap/name/exactandpotential/'
      }
      axios.get(url+searchterm)
        .then((response) => {
          resolve({users:response.data});
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }
  requestGetUsersInfo(idArray) {
    return new Promise ((resolve, reject) => {
        let ids = idArray.toString();
        
      axios.get('/api/v1/ldap/lookup/?ids='+ids)
        .then((response) => {
          resolve({users:response.data});
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }


}

export default new BaseMitCSAILLdapService();
